import React, { useState, useEffect } from "react"
import { Checkbox, Chip, Divider, FormControlLabel, Grid, IconButton, MenuItem, Paper, Stack, Tooltip, Typography } from "@mui/material"
import { toast } from "react-toastify"
import TextField from "../common/TextField"
import Button from "../common/Button"
import ConfirmDialoag from "../common/ConfirmDialoag"
import instance from "../../axios"
import moment from "moment"
import CustomDatePicker from "../common/CustomDatePicker"
import { useSelector } from "react-redux"
import AsyncSelect from "../common/asyncSelect"
import SingleSelect from "../common/SingleSelect"
import axios from "axios"
import { Add, Delete } from "@mui/icons-material"

let source
const getInitialForm = () => ({
    refNum: "",
    cn: null,
    refDate: null,
    accountId: null,
    description: "",
    zerovat: false,
    attributes: { quantityPriceScale: [{ expenseType: "", subTypes: "", expenseSubTypeId: null, quantity: "", price: "", description: "" }] },
})

const CreateUpdateForm = ({ translate, getInvoices, setIsShowAddForm }) => {
    const logInUser = useSelector((state) => state.logInUsers)
    const ServerSetting = useSelector((state) => state.ServerSetting)

    const [form, setForm] = useState(getInitialForm())
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
    const [quantityError, setQuantityError] = useState("")
    const [quantityHelperText, setQuantityHelperText] = useState("")
    const [deleteRowWarning, setDeleteRowWarning] = useState(false)
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [resultMessage, setResultMessage] = useState("")
    const [loader, setLoader] = useState(false)
    const [allExpenseTypes, setAllExpenseTypes] = useState([])
    const [allSubExpenseTypes, setAllSubExpenseTypes] = useState([])
    const [defaultAccountsList, setDefaultAccountsList] = useState([])

    useEffect(() => {
        fetchAccountsList()
    }, [])

    const fetchAccountsList = async () => {
        try {
            const fetchApi = `/api/accounts/getlimiteddata?search=&all=true&userId=${logInUser.id}`
            const response = await instance.get(fetchApi)
            const accounts = response?.map((acc) => ({
                ...acc,
                label: acc?.name || acc?.label,
                value: acc.id,
            })) || []

            if (ServerSetting?.id) {
                accounts.unshift({
                    id: ServerSetting.id,
                    label: ServerSetting.name,
                    value: ServerSetting.id,
                })
            }

            setDefaultAccountsList(accounts)
        } catch (err) {
            console.error("Failed to fetch accounts", err)
        }
    }

    const getExpenseTypes = (cn) => {
        let api = `api/expensetypes/get?contractNumber=${cn}&all=true&page=1&limit=-1`
        source = axios.CancelToken.source()
        axios
            .get(api, { cancelToken: source.token })
            .then((res) => {
                let response = res.data?.data
                setAllExpenseTypes(response?.data || [])
            })
            .catch((e) => { })
    }

    const getSubExpenseTypes = (expenseTypeId) => {
        let api = `/api/expensetypes/subtype/get?expenseTypeId=${expenseTypeId}&page=1&limit=20`
        source = axios.CancelToken.source()
        axios
            .get(api, { cancelToken: source.token })
            .then((res) => {
                const response = res.data?.data?.data || []
                const updatedResponse = response.map((item) => ({
                    ...item,
                    name: item.label || item.name,
                }))
                setAllSubExpenseTypes(updatedResponse)
            })
            .catch((e) => { })
    }

    const searchExpenseSubTypes = async (inputValue, expenseTypeId) => {
        if (!inputValue || !expenseTypeId) return []
        try {
            const fetchApi = `/api/expensetypes/subtype/get?expenseTypeId=${expenseTypeId?.id}&page=1&limit=20&search=${inputValue}`
            const response = await instance.get(fetchApi)
            const updatedResponse = response?.data || []
            setResultMessage(updatedResponse.length === 0 ? "No option found" : "")
            return updatedResponse.map((item) => ({ ...item, name: item.label || item.name }))
        } catch (err) {
            console.error(err)
            return []
        }
    }


    const searchAccountsList = async (inputValue) => {
        if (!inputValue) return []
        try {
            const fetchApi = `/api/accounts/getlimiteddata?search=${inputValue}&all=true&userId=${logInUser.id}`
            const response = await instance.get(fetchApi)
            const result = response?.map((acc) => ({
                ...acc,
                label: acc?.name || acc.label,
                name: acc.name,
                value: acc.id,
            })) || []
            setResultMessage(result.length === 0 ? "No option found" : "")
            return result
        } catch (err) {
            console.error(err)
            return []
        }
    }


    useEffect(() => {
        validateForm()
    }, [form, quantityError])

    const validateForm = () => {
        const hasEmpty = form.attributes.quantityPriceScale.some(
            (row) => !row.expenseType || !row.quantity || !row.price
        )
        setIsSubmitDisabled(!(form.refNum && form.refDate && form.cn && !quantityError && !hasEmpty))
    }


    const handleChange = (name, value) => {
        if (["quantity", "price"].includes(name) && value < 0) return
        if (name === "cn") {
            getExpenseTypes(value?.contractNumber)
            setForm((prev) => ({ ...prev, [name]: value }))
            return
        }
        setForm((prev) => ({ ...prev, [name]: value }))
    }

    const handleChangeDate = (name) => (date) => {
        const formatted = date ? moment(date).endOf("day").utc().format() : null
        setForm((prev) => ({ ...prev, [name]: formatted }))
    }
const recalcVat = (row) => {
    const VAT_RATE = 0.05;
    const quantity = Number(row.quantity) || 0;
    const price = Number(row.price) || 0;

    const base = quantity * price;
    const vat = base * VAT_RATE;

    return vat;
};
  const handleChangeScale = (field, value, index) => {
    const updated = [...form.attributes.quantityPriceScale];
    const numericFields = ["quantity", "price", "saleCost"];
    if (numericFields.includes(field) && value < 0) return;
    const nonNumericFields = [
        "expenseType", "subTypes", "expenseSubTypeId",
        "description", "itemName", "itemCode", "category", "saleCost"
    ];
    if (nonNumericFields.includes(field)) {
        if (field === "subTypes" && value) {
            updated[index].subTypes = value;
            updated[index].itemName = value.label || value.name || "";
            updated[index].itemCode = value.subTypeNum || "";
            updated[index].category = value.expenseType || "";
            updated[index].purchaseCost = parseFloat(value.purchasePrice) || 0;
            updated[index].price = parseFloat(value.unitPrice) || 0;
            updated[index].expenseSubTypeId = value.id || null;
            updated[index].quantity = 1;
        } else {
            updated[index][field] = value;
        }
    } else {
        updated[index][field] = parseFloat(value) || 0;
    }
    const quantity = parseFloat(updated[index].quantity) || 0;
    const price = parseFloat(updated[index].price) || 0;
const isZeroVat = form.zerovat;

const vat = isZeroVat
    ? 0
    : recalcVat({ ...updated[index], quantity, price });

updated[index].vat = parseFloat(vat) || 0;
// updated[index].vat = parseFloat(
//         recalcVat({ ...updated[index], quantity, price })
// ) || 0;

    updated[index].totalSingleItemCost = +(quantity * price + updated[index].vat).toFixed(2);
    if (field === "expenseType") {
        getSubExpenseTypes(updated[index].expenseType?.id);
        updated[index].subTypes = "";
        updated[index].expenseSubTypeId = null;
        updated[index].itemName = "";
        updated[index].itemCode = "";
        updated[index].vat = 0;
        updated[index].totalSingleItemCost = 0;
    }

    setForm((prev) => ({
        ...prev,
        attributes: { quantityPriceScale: updated },
    }));
};



    const handleAddMore = () => {
        setForm((prev) => ({
            ...prev,
            attributes: {
                quantityPriceScale: [...prev.attributes.quantityPriceScale, { expenseType: "", subTypes: "", expenseSubTypeId: null, quantity: "", price: "", description: "" }],
            },
        }))
    }

    const handleDelete = (index) => {
        if (form.attributes.quantityPriceScale.length === 1) {
            setDeleteRowWarning(true)
            return
        }
        const updated = [...form.attributes.quantityPriceScale]
        updated.splice(index, 1)
        setForm((prev) => ({ ...prev, attributes: { quantityPriceScale: updated } }))
    }

    const handleResetForm = () => setForm(getInitialForm())


    const handleSubmit = async () => {
        try {
            setLoader(true)
            const payload = {
                manualInvoice: {
                    contractNumber: form.cn?.contractNumber || "",
                    refNum: form.refNum,
                    refDate: form.refDate,
                    description: form.description,
                    // purchaseTotal: form.attributes.quantityPriceScale.reduce((sum, item) => sum + (item.price * item.quantity || 0), 0),
                    purchaseTotal: 0,
                    // quantity: form.attributes.quantityPriceScale.reduce((sum, item) => sum + (item.quantity || 0), 0),
                    quantity: 0,
                    // saleTotal: form.attributes.quantityPriceScale.reduce((sum, item) => sum + (item.saleCost || 0), 0),
                    saleTotal: 0,
                    saleVat: 0,
                    saleNet: 0,
                    invoiceDate: form.refDate,
                    attributes:{
                        accountName:form.cn?.name
                    }
                },
                manualInvoiceItems: form.attributes.quantityPriceScale.map((item) => ({
                    itemName: item?.itemName || "",
                    itemCode: item?.itemCode || "",
                    expenseType: item.expenseType?.name,
                    category: item.category || "",
                    quantity: item.quantity,
                    description: item.description,
                    purchaseCost: item.purchaseCost,
                    saleCost: item?.saleCost?.toFixed(2) || item?.price?.toFixed(2)||0,
                })),
            }
            await instance.post(`/api/manualinvoices?zerovat=${form.zerovat}`, payload)
            toast.success("Manual invoice saved successfully")
            getInvoices()
            setForm(getInitialForm())
            setIsShowAddForm((prev) => !prev)
        } catch (err) {
            toast.error("Failed to save")
            console.error(err)
        } finally {
            setLoader(false)
        }
    }

    const handleDeleteSubType = async () => {
        try {
            await instance.delete("/api/expensetypes/subtype/1") // replace with actual id
            toast.success("SubType deleted successfully")
            setShowDeleteConfirm(false)
            setForm(getInitialForm())
        } catch (err) {
            toast.error("Failed to delete")
            console.error(err)
        }
    }

    let serverTimeZone = logInUser?.attributes?.timezone || "Asia/Riyadh"

    return (
        <Grid style={{ padding: 20, backgroundColor: "white", minHeight: "400px" }}>
            <Paper
                elevation={0}
                sx={{
                    padding: "8px 8px",
                    marginBottom: 3,
                    backgroundColor: "#f5f5f5",
                    borderRadius: "2px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                }}
            >
                <Typography
                    variant="h5"
                    component="h4"
                    sx={{
                        fontWeight: "600",
                        color: "#333",
                    }}
                >
                    Create
                </Typography>
            </Paper>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField label={translate("invoiceRefNumber")} fullWidth margin="dense" value={form.refNum} onChange={(e) => handleChange("refNum", e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <CustomDatePicker format="DD/MM/YYYY" error={false} label={translate("date")} minDate={moment().tz(serverTimeZone)} fullWidth value={form.refDate ? moment.tz(form.refDate, serverTimeZone) : null} onChange={handleChangeDate("refDate")} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} style={{ zIndex: 99 }}>
                    <AsyncSelect selectName="cn" isMulti={false} isClearable value={form.cn} placeholder={translate("searchAccount")} resultMessage={resultMessage} defaultOptions={defaultAccountsList} handleChange={handleChange} loadOptions={searchAccountsList} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField label="Description" fullWidth margin="dense" value={form.description} onChange={(e) => handleChange("description", e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
<FormControlLabel
    control={
        <Checkbox
            checked={form.zerovat}
       onChange={(e) => {
    const checked = e.target.checked

    const updated = form.attributes.quantityPriceScale.map((row) => {
        const quantity = Number(row.quantity) || 0
        const price = Number(row.price) || 0
        const vat = checked ? 0 : quantity * price * 0.05

        return {
            ...row,
            vat,
            totalSingleItemCost: +(quantity * price + vat).toFixed(2),
        }
    })

    setForm((prev) => ({
        ...prev,
        zerovat: checked,
        attributes: { quantityPriceScale: updated },
    }))
}}
        />
    }
    label="Zero VAT (Apply to all items)"
/>
</Grid>
            </Grid>
            <Divider sx={{ borderBottomWidth: 2, borderColor: "#ccc", borderStyle: "dashed", my: 1.5 }} />

            <Grid container style={{ marginTop: 5 }}>
                {form.attributes.quantityPriceScale.map((item, index) => (
                    <Grid container spacing={1} key={index}
                        sx={{
                            paddingY: 1,
                            borderBottom: index !== form.attributes.quantityPriceScale.length - 1 ? "1px dashed #ccc" : "none"
                        }}>
                        <Grid item xs={12} md={3}>
                            <TextField select label={translate("type")} value={item.expenseType || ""} onChange={(e) => handleChangeScale("expenseType", e.target.value, index,)} margin="dense" fullWidth required>
                                {allExpenseTypes.map((option) => (
                                    <MenuItem key={option.id} value={option}>
                                        {translate(option.name)}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <SingleSelect
                                id="expenseSubTypeId"

                                array={allSubExpenseTypes || []}
                                async
                                isClearable
                                selectName="subTypes"
                                loadOptions={(inputValue) => searchExpenseSubTypes(inputValue, item.expenseType)}
                                label={translate("subTypes")}
                                value={item.subTypes ? { id: item.subTypes.id, value: item.subTypes.id, label: item.subTypes.label } : ""}
                                index={index}
                                handleChange={handleChangeScale}
                                canRemove={true}
                                canAssign={true}
                                menuPlacement="auto"
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField label="Quantity" type="number" fullWidth margin="dense" value={item.quantity} onChange={(e) => handleChangeScale("quantity", e.target.value, index)} error={index === form.attributes.quantityPriceScale.length - 1 && quantityError !== ""} helperText={index === form.attributes.quantityPriceScale.length - 1 ? quantityHelperText : ""} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField label="Price" type="number" fullWidth margin="dense" value={item.price} onChange={(e) => handleChangeScale("price", e.target.value, index)} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField label={translate("description")} type="text" fullWidth margin="dense" value={item.description} onChange={(e) => handleChangeScale("description", e.target.value, index)} />
                        </Grid>
                        {/* {item?.vat&& */}
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField label="vat" type="text" fullWidth margin="dense" disabled={item.vat || true} value={item.vat || ""} onChange={(e) => handleChangeScale("vat", e.target.value, index)} />
                        </Grid>
                        {/* } */}

                        <Grid item xs={12} sm={6} md={3}>
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                justifyContent="flex-start"
                                mt={1}
                            >
                                {/* Total Cost */}
                                <Chip
                                    label={`Total: ${item?.totalSingleItemCost?.toFixed(2) || "0.00"}`}
                                    color="primary"
                                    variant="outlined"
                                    sx={{
                                        fontWeight: 600,
                                        minWidth: 120,
                                        justifyContent: "center",
                                    }}
                                />

                                {/* Add */}
                                <Tooltip title="Add another item">
                                    <IconButton
                                        size="small"
                                        sx={{
                                            bgcolor: "success.light",
                                            color: "success.contrastText",
                                            "&:hover": {
                                                bgcolor: "success.main",
                                                color: "success.contrastText",
                                            },
                                        }}
                                        onClick={handleAddMore}
                                    >
                                        <Add />
                                    </IconButton>
                                </Tooltip>

                                {/* Delete */}
                                <Tooltip title="Remove this item">
                                    <IconButton
                                        size="small"
                                        sx={{
                                            bgcolor: "error.main",
                                            color: "error.contrastText",
                                            "&:hover": {
                                                bgcolor: "error.dark",
                                            },
                                        }}
                                        onClick={() => handleDelete(index)}
                                    >
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </Grid>

                    </Grid>
                ))}
            </Grid>

            {/* ACTION BUTTONS */}
            <div style={{ display: "flex", marginTop: 10 }}>
                <div style={{ marginLeft: "auto" }} />
                <Button size="small" style={{ marginRight: 15 }} onClick={handleResetForm}>
                    Reset
                </Button>
                <Button size="small" onClick={handleSubmit} disabled={isSubmitDisabled}>
                    Save
                </Button>
            </div>

            {/* DELETE CONFIRMATION */}
            {showDeleteConfirm && <ConfirmDialoag onCancel={() => setShowDeleteConfirm(false)} onOk={handleDeleteSubType} title="Are you sure you want to delete this subtype?" children={form.label} />}
            {deleteRowWarning && <ConfirmDialoag onCancel={() => setDeleteRowWarning(false)} onOk={() => setDeleteRowWarning(false)} title="Cannot delete last row" />}
        </Grid>
    )
}

export default CreateUpdateForm
